import { SeoProps } from '@/shared/seo/SeoHead'

const APP_NAME = 'Stoux.fr'
const APP_DESCRIPTION =
    "Découvrez sur Stoux.fr une vaste sélection de jeux-vidéos, mangas, et accessoires. Redonnez vie à vos passions dans l'univers de la pop culture. Trouvez vos classiques et dernières nouveautés ici !"
const APP_URL = 'https://www.stoux.fr'

const config: SeoProps = {
    titleTemplate: `%s | ${APP_NAME}`,
    defaultTitle: `Stoux.fr : Jeux-Vidéos, Mangas, Consoles - Univers de la Pop Culture`,
    description: APP_DESCRIPTION,
    canonical: APP_URL,
    openGraph: {
        type: 'website',
        locale: 'fr_FR',
        url: APP_URL,
        site_name: APP_NAME,
        images: [
            {
                url: `${APP_URL}/images/core/stoux-icon.svg`,
                width: 1200,
                height: 630,
                alt: 'Image principale de Stoux.fr - Univers de la Pop Culture avec jeux-vidéos, mangas et accessoires',
            },
        ],
    },
}

export default config
